import { cn } from "@moe/priv/utils";
import { AvatarGroup } from "@web/components/AvatarGroup";
import { useDataContext } from "@web/route-services/chat/data-context";
import { useServiceContext } from "@web/route-services/chat/service-context";
import { motion } from "motion/react";
import { FaDice } from "react-icons/fa";

interface Props {
  open: boolean;
  className?: string;
  [x: string]: any;
}

export function GroupChatTurnControl({ open, className, ...rest }: Props) {
  const { service } = useServiceContext();
  const { chars } = useDataContext();

  const avatars = Array.from(chars.values()).map((char) => ({
    url: char.avatar,
    onClick: () => {
      service.generate(char.id);
    }
  }));

  return (
    <motion.div
      style={{ transformOrigin: "top" }}
      animate={{
        height: open ? "auto" : 0,
        opacity: open ? 1 : 0,
        scale: open ? 1 : 0.5,
        x: open ? 0 : "-25%"
      }}
      initial={false}
      transition={{ duration: 0.2, ease: "easeIn", opacity: { duration: open ? 0.2 : 0.15 } }}
      className={cn("flex overflow-x-auto overflow-y-hidden px-5 py-1 md:mb-0", className)}
      {...rest}
    >
      <motion.button
        className="mr-4 md:mr-6"
        whileHover={{ scale: 1.16 }}
        whileTap={{ scale: 0.8, rotate: 360 }}
        onClick={() => {
          service.continue();
        }}
      >
        <FaDice className="text-tx-tertiary active:text-tx-primary size-8 transition-colors duration-300 ease-out focus:outline-none" />
      </motion.button>

      <AvatarGroup
        avatars={avatars}
        maxWidth="calc(100% - 3rem)"
        className="space-x-2 pl-1"
        avatarClassName="h-9 w-9 ring-0 shadow-sm md:h-11 md:w-11 outline-none hover:scale-[1.16]  hover:brightness-110  active:scale-95"
      />
    </motion.div>
  );
}
